export default __webpack_public_path__ + "static/more-3da5c09e31f8fd4a168de60899a8736d.jpg";